module.exports = __webpack_public_path__ + "media/assets/images/events/mkithp_san_marco-d6fc20b09cc4c56b8171ecff8637c345.png";